import {Endpoints} from '../../../globals/api/endpoints';

export class VersionEndpoints extends Endpoints {

  private static readonly VERSIONS = VersionEndpoints.VIEWER + '/version';
  public static readonly VERSION = VersionEndpoints.VERSIONS + '/' + VersionEndpoints.PROJECT_ID;
  public static readonly VERSION_PREVIEW = VersionEndpoints.VERSIONS + '/' + VersionEndpoints.VERSION_ID + '/preview';
}
